// IocPagination.jsx 🧩🧭 Full Nav Upgrade
import React, { useEffect } from "react";

const IocPagination = ({ page, totalPages, onPageChange }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowLeft" && page > 1) onPageChange(page - 1);
      if (e.key === "ArrowRight" && page < totalPages) onPageChange(page + 1);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [page, totalPages, onPageChange]);

  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (page >= totalPages - 3) {
        pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }
    return pages;
  };

  const pageBtnStyle = (isActive = false) => ({
    backgroundColor: isActive ? "#323232" : "#1e1e1e",
    color: "#f8f9fa",
    border: "1px solid #313131",
    padding: "8px 12px",
  });

  return (
    <div className="d-flex justify-content-center my-4">
      <ul className="pagination justify-content-center" style={{ margin: "20px 0" }}>
        {/* « First */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            style={pageBtnStyle()}
            onClick={() => onPageChange(1)}
            disabled={page === 1}
          >
            <i className="bi bi-chevron-double-left"></i>
          </button>
        </li>

        {/* ‹ Prev */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            style={pageBtnStyle()}
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            <i className="bi bi-chevron-left"></i>
          </button>
        </li>

        {/* Pages */}
        {getVisiblePages().map((p, idx) =>
          p === "..." ? (
            <li key={`ellipsis-${idx}`} className="page-item disabled">
              <span className="page-link" style={pageBtnStyle()}>
                ...
              </span>
            </li>
          ) : (
            <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
              <button
                className="page-link"
                style={pageBtnStyle(page === p)}
                onClick={() => onPageChange(p)}
              >
                {p}
              </button>
            </li>
          )
        )}

        {/* › Next */}
        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            style={pageBtnStyle()}
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </li>

        {/* » Last */}
        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            style={pageBtnStyle()}
            onClick={() => onPageChange(totalPages)}
            disabled={page === totalPages}
          >
            <i className="bi bi-chevron-double-right"></i>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default IocPagination;
